const zh = {
  i18nView: {
    mainIntro: '将社交回归到该有的样子，能否掀起一股新的社交网络革命？作为EOS上第一个超级合约，Voice又会给EOS带来什么？我们拭目以待！',
    website: '官网',
    view: '国内用户需梯子',
    aboutVoice: '关于Voice',
    whatisVoice: '什么是Voice',
    howtoVoice: '怎么申请',
    whattosay: '大家怎么说',
    voicesay: 'Voice团队说',
    communitysay: '社区声音',
    whatismore: '更多内容',
    voiceQA: 'Voice 问与答',
    relativeReport: '相关报道'
  }
};

export default zh;